module.exports = __webpack_public_path__ + "assets/images/extra-04.588cbaea93e47363118cc9df2bcdb12f.svg";